import { pageHead, unavailableHead, hasUnavailableMatch } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import FranchiseOpportunities from "@/pages/FranchiseOpportunities";

export const Route = createFileRoute("/_public/franchise-opportunities")({
  head: ({ matches }) => hasUnavailableMatch(matches) ? unavailableHead() : pageHead("Fence Franchise Opportunities \u2014 Turnkey Cable-Rail Fence Business", "Own the modern fence category in your state. $10k franchise fee, warm leads, website, AI sales avatar, and live install support. 40+ states open \u2014 apply today.", "/franchise-opportunities", false),
  component: FranchiseOpportunities,
});
